import { Box, styled, Typography } from "@mui/material";

export const StyledCardHeaderTitleContainer = styled(Box)(
  ({ theme }) => `
  display:flex;
   ${theme.breakpoints.down("sm")}{
     flex-direction:column;
   }
  `
);
export const StyledTitle = styled(Typography)(
  ({ theme }) => `
   ${theme.breakpoints.down("sm")}{
     display:none;
   }
  `
);
export const StyledText = styled(Typography)`
   font-size:0.8rem;
   text-transform:uppercase;
    font-family:Gotham-Medium;
    ${(props) => props.theme.breakpoints.down("sm")}{
      font-size:0.7rem;
      text-transform:unset;
    }
   }
  `;
export const StyledTextKey = styled(Typography)`
    font-family:Gotham-Light;
    font-weight:bold;
    text-transform:uppercase;
    font-size:0.7rem;
   }
  `;

export const KeyValueBoxContainer = styled(Box)`
  & div:not(:last-child) {
    margin-right: 2.5rem;
  }
`;
export const OrderStatusContainer = styled(Box)`
  // background: ${({ theme }) => theme.palette.primary.light};
  // border-radius: 5px;
  // display: flex;
  // align-items: center;
  // padding: 5px;
  flex:1;
  & p{

    text-align:right
  }
`;
export const StyledAddressBox = styled(Box)`
  background: ${({ theme }) => theme.palette.secondary.light};
  padding: 1rem;
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
  & div {
    & p {
      font-size: 0.8rem;
      text-transform: capitalize;
    }
  }
  & p,
  div {
    & p,
    h2 {
      margin-bottom: 0.2rem;
    }
  }
  div:last-child {
    & p {
      margin-bottom: 0.2rem;
    }
  }
`;
